module.exports = __webpack_public_path__ + "static/img/pro.3af84543.png";